<div class="partners__list">
  <app-partner-card
    *ngFor="let partner of partners | async"
    [partner]="partner"
  ></app-partner-card>
</div>
